var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isReadOnly
        ? _c(
            "b-row",
            { staticClass: "pb-1" },
            [
              _c(
                "b-col",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c("e-button", {
                    attrs: { variant: "primary", text: _vm.$t("Adicionar") },
                    on: { click: _vm.onShowSidebar },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-table", {
                ref: "pix-table",
                staticClass: "bordered",
                attrs: {
                  "show-empty": "",
                  responsive: "",
                  fields: _vm.fields,
                  items: _vm.pixs,
                  "empty-text": _vm.emptyTableMessage,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(active)",
                    fn: function (row) {
                      return [
                        _c("e-status-badge", {
                          attrs: { status: row.item.active },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(action)",
                    fn: function (row) {
                      return [
                        _c("e-grid-actions", {
                          attrs: { "show-update": true, "show-delete": true },
                          on: {
                            update: function ($event) {
                              return _vm.onShowSidebar(row)
                            },
                            delete: function ($event) {
                              return _vm.deletePix(row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.isReadOnly
        ? _c("e-sidebar", {
            attrs: {
              show: _vm.showSidebar,
              fetching: _vm.loading,
              title: _vm.isEdit ? _vm.$t("Alterar PIX") : _vm.$t("Novo PIX"),
              width: "600px",
            },
            on: {
              save: _vm.addBankClick,
              hidden: function ($event) {
                _vm.showSidebar = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "FormulateForm",
                        { ref: "formPix", attrs: { name: "formPix" } },
                        [
                          _c(
                            "b-card-actions",
                            {
                              attrs: { title: _vm.$t("PIX"), "no-actions": "" },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "4" } },
                                    [
                                      _c("FormulateInput", {
                                        staticClass: "required",
                                        attrs: {
                                          id: "pix-type",
                                          type: "vue-select",
                                          label: _vm.$t("Tipo"),
                                          validation: "required",
                                          placeholder: _vm.$t("Selecione"),
                                          options: _vm.pixTypes(),
                                        },
                                        model: {
                                          value: _vm.pixForm.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.pixForm, "type", $$v)
                                          },
                                          expression: "pixForm.type",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "8" } },
                                    [
                                      _c("FormulateInput", {
                                        staticClass: "required",
                                        attrs: {
                                          id: "pix-key",
                                          type: "text",
                                          label: _vm.$t("Chave"),
                                          validation: "required",
                                        },
                                        model: {
                                          value: _vm.pixForm.key,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.pixForm, "key", $$v)
                                          },
                                          expression: "pixForm.key",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "8" } },
                                    [
                                      _c("FormulateInput", {
                                        staticClass: "required",
                                        attrs: {
                                          id: "pix-name",
                                          type: "text",
                                          label: _vm.$t("Nome"),
                                          validation: "required",
                                        },
                                        model: {
                                          value: _vm.pixForm.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.pixForm, "name", $$v)
                                          },
                                          expression: "pixForm.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-card-actions",
                            { attrs: { "no-actions": "" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { "align-h": "end" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "2" } },
                                    [
                                      _c("FormulateInput", {
                                        attrs: {
                                          id: "pix-active",
                                          type: "switch",
                                          label: _vm.$t("Ativo?"),
                                        },
                                        model: {
                                          value: _vm.pixForm.active,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.pixForm, "active", $$v)
                                          },
                                          expression: "pixForm.active",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1930930888
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }